const ColumnsUnidata = [
    { field: 'ID', headerName: 'ID', width: 230, sortable:false },
    { field: 'POP', headerName: 'POP', width: 230, sortable:false },
    { field: 'Comune', headerName: 'Comune', width: 230, sortable:false },
    { field: 'Particella', headerName: 'Particella', width: 230, sortable:false },
    { field: 'Via', headerName: 'Via', width: 230, sortable:false },
    { field: 'Civico', headerName: 'Civico', width: 30, sortable:false },
    { field: 'Provincia', headerName: 'Provincia', width: 230, sortable:false },
    { field: 'Scala_Palazzina', headerName: 'Scala_Palazzina', width: 230, sortable:false },
    { field: 'Stato_Building', headerName: 'Stato_Building', width: 230, sortable:false },
    { field: 'Descrizione_Stato', headerName: 'Descrizione_Stato', width: 230, sortable:false },
    { field: 'Servizio', headerName: 'Servizio', width: 230, sortable:false },
];
export default ColumnsUnidata;